<template>
    <div>
        <TransitionRoot as="template" :show="sidebarOpen">
            <Dialog
                as="div"
                class="fixed inset-0 z-40 flex md:hidden"
                @close="sidebarOpen = false"
            >
                <TransitionChild
                    as="template"
                    enter="transition-opacity ease-linear duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="transition-opacity ease-linear duration-300"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <DialogOverlay class="fixed inset-0 bg-gray-600/75" />
                </TransitionChild>
                <TransitionChild
                    as="template"
                    enter="transition ease-in-out duration-300 transform"
                    enter-from="-translate-x-full"
                    enter-to="translate-x-0"
                    leave="transition ease-in-out duration-300 transform"
                    leave-from="translate-x-0"
                    leave-to="-translate-x-full"
                >
                    <div
                        class="relative flex w-full max-w-xs flex-1 flex-col bg-[#131022] pb-4 pt-5"
                    >
                        <TransitionChild
                            as="template"
                            enter="ease-in-out duration-300"
                            enter-from="opacity-0"
                            enter-to="opacity-100"
                            leave="ease-in-out duration-300"
                            leave-from="opacity-100"
                            leave-to="opacity-0"
                        >
                            <div class="absolute right-0 top-0 -mr-12 pt-2">
                                <button
                                    type="button"
                                    class="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                    @click="sidebarOpen = false"
                                >
                                    <span class="sr-only">Close sidebar</span>
                                    <XMarkIcon
                                        class="h-6 w-6 text-white"
                                        aria-hidden="true"
                                    />
                                </button>
                            </div>
                        </TransitionChild>
                        <div class="flex shrink-0 items-center px-4">
                            <img
                                class="h-8 w-auto"
                                src="https://d2ucq9llvgnbyn.cloudfront.net/signature-white.png"
                                alt="Ticto"
                            />
                        </div>
                        <div class="mt-5 h-0 flex-1 overflow-y-auto">
                            <nav class="space-y-1 px-2">
                                <!--                                <router-link-->
                                <!--                                    v-for="item in navigation"-->
                                <!--                                    :key="item.name"-->
                                <!--                                    :to="item.route"-->
                                <!--                                    :class="[-->
                                <!--                                        item.current-->
                                <!--                                            ? 'bg-gray-900 text-white'-->
                                <!--                                            : 'text-gray-300 hover:bg-gray-700 hover:text-white',-->
                                <!--                                        'group flex items-center rounded-md px-2 py-2 text-base font-medium',-->
                                <!--                                    ]"-->
                                <!--                                >-->
                                <!--                                    <component-->
                                <!--                                        :is="item.icon"-->
                                <!--                                        :class="[-->
                                <!--                                            item.current-->
                                <!--                                                ? 'text-gray-300'-->
                                <!--                                                : 'text-gray-400 group-hover:text-gray-300',-->
                                <!--                                            'mr-4 h-6 w-6 shrink-0',-->
                                <!--                                        ]"-->
                                <!--                                        aria-hidden="true"-->
                                <!--                                    />-->
                                <!--                                    {{ item.name }}-->
                                <!--                                </router-link>-->
                            </nav>
                        </div>
                    </div>
                </TransitionChild>
                <div class="w-14 shrink-0" aria-hidden="true">
                    <!-- Dummy element to force sidebar to shrink to fit close icon -->
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Static sidebar for desktop -->
        <div
            class="hidden transition-transform duration-300 ease-in-out md:fixed md:inset-y-0 md:z-20 md:flex md:w-56 md:flex-col"
            :class="
                sidebarCollapsed
                    ? 'pointer-events-none -translate-x-full'
                    : 'translate-x-0'
            "
        >
            <div
                class="sidebar-desktop flex min-h-0 w-56 flex-1 flex-col border-r border-white/5 bg-[#131022]"
            >
                <div
                    class="flex h-14 shrink-0 items-center border-b border-white/5 px-4"
                >
                    <img
                        class="h-7 w-auto"
                        src="https://d2ucq9llvgnbyn.cloudfront.net/signature-white.png"
                        alt="Ticto"
                    />
                </div>
                <div
                    class="sidebar-nav-scroll flex flex-1 flex-col overflow-y-auto"
                >
                    <nav class="flex-1 px-3 py-3">
                        <template v-if="!permissions">
                            <div
                                v-for="index in 12"
                                :key="`skeleton-${index}`"
                                class="group flex animate-pulse items-center rounded-lg px-2 py-1.5"
                            >
                                <div
                                    class="h-4 w-4 rounded-full bg-white/10"
                                ></div>
                                <div
                                    class="ml-3 h-2 grow rounded bg-white/10"
                                ></div>
                            </div>
                        </template>

                        <template v-else>
                            <div
                                v-if="showMenuHint"
                                class="mb-2 rounded-lg border border-indigo-400/30 bg-indigo-500/10 p-2.5"
                            >
                                <p
                                    class="text-[12px] leading-snug text-slate-300"
                                >
                                    Menu novo, agrupado por área. Prefere a
                                    ordem antiga?
                                </p>
                                <div class="mt-2 flex gap-2">
                                    <button
                                        type="button"
                                        class="rounded-md bg-indigo-500 px-2 py-1 text-[11px] font-medium text-white hover:bg-indigo-400"
                                        @click="chooseMenuLayout(true)"
                                    >
                                        Manter novo
                                    </button>
                                    <button
                                        type="button"
                                        class="rounded-md border border-white/15 px-2 py-1 text-[11px] font-medium text-slate-300 hover:bg-white/5"
                                        @click="chooseMenuLayout(false)"
                                    >
                                        Ordem antiga
                                    </button>
                                </div>
                            </div>

                            <div
                                v-for="group in visibleNavigation"
                                :key="group.label"
                                class="mb-1"
                            >
                                <p
                                    v-if="group.label"
                                    class="px-2 pb-1 pt-3 text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-500"
                                >
                                    {{ group.label }}
                                </p>
                                <router-link
                                    v-for="item in group.items"
                                    :key="item.name + (item.route?.name ?? '')"
                                    :to="item.route"
                                    class="group mb-0.5 flex min-w-0 items-center whitespace-nowrap rounded-lg px-2 py-1.5 text-[13px] font-medium transition-colors"
                                    active-class="bg-indigo-500/15 text-white"
                                    :class="
                                        item.prefix &&
                                        isRouteActive(item.prefix)
                                            ? 'bg-indigo-500/15 text-white'
                                            : 'text-slate-400 hover:bg-white/5 hover:text-white'
                                    "
                                >
                                    <component
                                        :is="item.icon"
                                        class="mr-2.5 h-4.5 w-4.5 shrink-0"
                                        :class="
                                            item.prefix &&
                                            isRouteActive(item.prefix)
                                                ? 'text-indigo-400'
                                                : 'text-slate-500 group-hover:text-slate-300'
                                        "
                                        aria-hidden="true"
                                    />
                                    <span class="truncate">{{
                                        item.name
                                    }}</span>
                                    <button
                                        type="button"
                                        class="ml-auto shrink-0 rounded p-0.5 opacity-0 transition-opacity focus-visible:opacity-100 group-hover:opacity-100"
                                        :class="
                                            favorites.includes(item.name)
                                                ? 'text-amber-400 opacity-100'
                                                : 'text-slate-500 hover:text-slate-300'
                                        "
                                        :aria-label="
                                            favorites.includes(item.name)
                                                ? 'Remover dos favoritos'
                                                : 'Adicionar aos favoritos'
                                        "
                                        @click.prevent.stop="
                                            toggleFavorite(item.name)
                                        "
                                    >
                                        <StarIconSolid
                                            v-if="favorites.includes(item.name)"
                                            class="h-3.5 w-3.5"
                                            aria-hidden="true"
                                        />
                                        <StarIcon
                                            v-else
                                            class="h-3.5 w-3.5"
                                            aria-hidden="true"
                                        />
                                    </button>
                                </router-link>
                            </div>
                        </template>
                    </nav>

                    <button
                        type="button"
                        class="flex items-center gap-2 border-t border-white/5 px-4 py-2.5 text-left text-[11px] font-medium text-slate-500 transition-colors hover:text-slate-300"
                        @click="chooseMenuLayout(!sidebarGrouped)"
                    >
                        <span
                            class="relative inline-flex h-3.5 w-6 items-center rounded-full transition-colors"
                            :class="
                                sidebarGrouped ? 'bg-indigo-500' : 'bg-white/15'
                            "
                        >
                            <span
                                class="inline-block h-2.5 w-2.5 transform rounded-full bg-white transition-transform"
                                :class="
                                    sidebarGrouped
                                        ? 'translate-x-3'
                                        : 'translate-x-0.5'
                                "
                            ></span>
                        </span>
                        Menu agrupado por área
                    </button>
                </div>
            </div>
        </div>
        <div
            class="flex w-full flex-1 flex-col transition-[padding] duration-300 ease-in-out"
            :class="sidebarCollapsed ? 'md:pl-0' : 'md:pl-56'"
        >
            <div
                class="sticky top-0 z-10 flex h-14 w-full shrink-0 items-center border-b border-black/5 bg-white/75 backdrop-blur dark:border-white/5 dark:bg-[#0D0A16]/75"
            >
                <button
                    type="button"
                    class="px-4 text-gray-500 hover:text-gray-900 focus:outline-none dark:text-gray-400 dark:hover:text-white md:hidden"
                    @click="sidebarOpen = true"
                >
                    <span class="sr-only">Open sidebar</span>
                    <Bars3Icon class="h-6 w-6" aria-hidden="true" />
                </button>
                <button
                    type="button"
                    class="hidden px-4 text-gray-500 hover:text-gray-900 focus:outline-none dark:text-gray-400 dark:hover:text-white md:flex md:items-center"
                    @click="sidebarCollapsed = !sidebarCollapsed"
                >
                    <span class="sr-only">
                        {{
                            sidebarCollapsed
                                ? "Expand sidebar"
                                : "Collapse sidebar"
                        }}
                    </span>
                    <svg
                        class="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                    >
                        <rect x="3" y="3" width="18" height="18" rx="2" />
                        <path d="M9 3v18" />
                    </svg>
                </button>
                <div
                    class="flex w-full flex-1 items-center justify-between gap-4 px-4"
                >
                    <button
                        type="button"
                        class="hidden w-64 items-center gap-2 rounded-lg border border-black/10 bg-black/[0.03] px-3 py-1.5 text-left text-[13px] text-gray-400 transition-colors hover:border-black/20 hover:text-gray-600 focus:outline-none dark:border-white/10 dark:bg-white/[0.04] dark:hover:border-white/20 dark:hover:text-gray-300 sm:flex"
                        @click="paletteOpen = true"
                    >
                        <MagnifyingGlassIcon
                            class="h-4 w-4"
                            aria-hidden="true"
                        />
                        <span class="flex-1">Ir para tela ou seller...</span>
                        <kbd
                            class="rounded border border-black/10 px-1.5 py-px font-mono text-[10px] text-gray-400 dark:border-white/15"
                        >
                            ⌘K
                        </kbd>
                    </button>

                    <div class="ml-auto flex items-center">
                        <button
                            type="button"
                            @click="dark = !dark"
                            class="rounded-full p-1.5 text-gray-500 hover:text-gray-900 focus:outline-none dark:text-gray-400 dark:hover:text-white sm:mr-1"
                        >
                            <span class="sr-only">Alternar tema</span>
                            <component
                                :is="dark ? 'SunIcon' : 'MoonIcon'"
                                class="h-5 w-5"
                                aria-hidden="true"
                            />
                        </button>

                        <button
                            type="button"
                            class="rounded-full p-1.5 text-gray-500 hover:text-gray-900 focus:outline-none dark:text-gray-400 dark:hover:text-white"
                        >
                            <span class="sr-only">Notificações</span>
                            <BellIcon class="h-5 w-5" aria-hidden="true" />
                        </button>

                        <!-- Profile dropdown -->
                        <Menu as="div" class="relative ml-3">
                            <div>
                                <MenuButton
                                    class="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-0"
                                >
                                    <span class="sr-only">Open user menu</span>
                                    <img
                                        class="h-8 w-8 rounded-full"
                                        :src="
                                            authUser.avatar ||
                                            'https://api.dicebear.com/7.x/initials/svg?backgroundColor=c0aede&seed=' +
                                                authUser.name
                                        "
                                        alt=""
                                    />
                                </MenuButton>
                            </div>
                            <transition
                                enter-active-class="transition duration-100 ease-out"
                                enter-from-class="transform scale-95 opacity-0"
                                enter-to-class="transform scale-100 opacity-100"
                                leave-active-class="transition duration-75 ease-in"
                                leave-from-class="transform scale-100 opacity-100"
                                leave-to-class="transform scale-95 opacity-0"
                            >
                                <MenuItems
                                    class="absolute right-0 mt-2 w-48 origin-top-right rounded-xl border border-black/5 bg-white py-1 shadow-lg focus:outline-none dark:border-white/10 dark:bg-[#161926]"
                                >
                                    <MenuItem
                                        v-for="item in userNavigation"
                                        :key="item.name"
                                        @click="close"
                                        v-slot="{ active, close }"
                                    >
                                        <button
                                            @click="
                                                close();
                                                item.route
                                                    ? $router.push(item.route)
                                                    : '';
                                            "
                                            v-if="item.name !== 'Sair'"
                                            active-class="bg-gray-100"
                                            class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-black/5 dark:text-gray-200 dark:hover:bg-white/5"
                                        >
                                            {{ item.name }}
                                        </button>
                                        <button
                                            v-else
                                            @click.prevent="logout"
                                            class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-black/5 dark:text-gray-200 dark:hover:bg-white/5"
                                        >
                                            Sair
                                        </button>
                                    </MenuItem>
                                </MenuItems>
                            </transition>
                        </Menu>
                    </div>
                </div>
            </div>

            <main class="flex-1">
                <div class="py-2">
                    <div class="mx-auto max-w-full px-4 sm:px-5">
                        <ticto-loading v-if="!permissions" />
                        <div v-show="permissions">
                            <router-view v-slot="{ Component }">
                                <transition name="page" mode="out-in" appear>
                                    <div :key="pageTransitionKey">
                                        <component :is="Component" />
                                    </div>
                                </transition>
                            </router-view>
                        </div>
                    </div>
                </div>
            </main>
        </div>

        <command-palette
            :open="paletteOpen"
            :navigation="allowedNavigation"
            @close="paletteOpen = false"
        />

        <export-progress-card />
    </div>
</template>

<script>
import PermissionMixin from "../../mixins/PermissionMixin.vue";

import {
    Dialog,
    DialogOverlay,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import {
    BanknotesIcon,
    Bars3Icon,
    StarIcon,
    BellIcon,
    ChartBarIcon,
    FolderIcon,
    InboxIcon,
    MagnifyingGlassIcon,
    UsersIcon,
    XMarkIcon,
} from "@heroicons/vue/20/solid";
import {
    AcademicCapIcon,
    ArchiveBoxIcon,
    BellAlertIcon,
    BookOpenIcon,
    BriefcaseIcon,
    ChartBarSquareIcon,
    ChatBubbleLeftEllipsisIcon,
    Cog8ToothIcon,
    CurrencyDollarIcon,
    DevicePhoneMobileIcon,
    EnvelopeIcon,
    ExclamationTriangleIcon,
    MegaphoneIcon,
    MoonIcon,
    ScaleIcon,
    ShieldCheckIcon,
    SignalIcon,
    SunIcon,
    UserGroupIcon,
    UserIcon,
    VideoCameraIcon,
    WalletIcon,
} from "@heroicons/vue/24/outline";
import {
    Square3Stack3DIcon,
    StarIcon as StarIconSolid,
} from "@heroicons/vue/24/solid";
import { mapActions, mapWritableState } from "pinia";
import CommandPalette from "../../components/layouts/CommandPalette.vue";
import ExportProgressCard from "../../components/export/ExportProgressCard.vue";
import TictoLoading from "../../components/layouts/TictoLoading.vue";
import ColSkeleton from "../../components/layouts/skeleton/ColSkeleton.vue";
import { Store } from "../../stores/store";
import permissions from "../users/permissions/Permissions.vue";

export default {
    mixins: [PermissionMixin],
    components: {
        TictoLoading,
        ColSkeleton,
        CommandPalette,
        ExportProgressCard,
        Dialog,
        DialogOverlay,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        TransitionChild,
        TransitionRoot,
        BellIcon,
        Bars3Icon,
        MagnifyingGlassIcon,
        XMarkIcon,
        MoonIcon,
        ShieldCheckIcon,
        SunIcon,
        BanknotesIcon,
        ArchiveBoxIcon,
        UserGroupIcon,
        MegaphoneIcon,
        FolderIcon,
        BookOpenIcon,
        BriefcaseIcon,
        ChartBarIcon,
        InboxIcon,
        ChartBarSquareIcon,
        ShieldCheckIcon,
        Square3Stack3DIcon,
        DevicePhoneMobileIcon,
        VideoCameraIcon,
        Cog8ToothIcon,
        ExclamationTriangleIcon,
        AcademicCapIcon,
        WalletIcon,
        UserIcon,
        StarIcon,
        StarIconSolid,
    },

    data() {
        return {
            sidebarOpen: false,
            sidebarCollapsed: false,
            paletteOpen: false,
            sidebarGrouped:
                localStorage.getItem("smaug_sidebar_grouped") !== "0",
            favorites: (() => {
                try {
                    const stored = JSON.parse(
                        localStorage.getItem("smaug_sidebar_favorites"),
                    );
                    return Array.isArray(stored) ? stored : [];
                } catch {
                    return [];
                }
            })(),
            showMenuHint:
                localStorage.getItem("smaug_sidebar_grouped") === null,
            navigation: [
                {
                    name: "Usuários",
                    route: { name: "users" },
                    icon: UsersIcon,
                    permission: "view.users",
                    prefix: "/user",
                },
                {
                    name: "Trocas de E-mail",
                    route: { name: "producer-email-change-requests" },
                    icon: EnvelopeIcon,
                    permission: "manage.producer_email_change_requests",
                    prefix: "/producer-email-change-requests",
                },
                {
                    name: "Compliance",
                    route: { name: "compliance" },
                    icon: ChatBubbleLeftEllipsisIcon,
                    permission: "view.users",
                    prefix: "/compliance",
                },
                {
                    name: "FDIC",
                    route: { name: "fdic.submissions" },
                    icon: BanknotesIcon,
                    permission: "view.fdic",
                    prefix: "/fdic",
                },
                {
                    name: "Auditoria",
                    route: { name: "auditoria" },
                    icon: ShieldCheckIcon,
                    permission: "view.auditoria",
                    prefix: "/auditoria",
                },
                {
                    name: "Produtos",
                    route: { name: "products" },
                    permission: "view.products",
                    icon: Square3Stack3DIcon,
                    prefix: "/product",
                },
                {
                    name: "Vendas",
                    route: { name: "orders" },
                    permission: "view.orders",
                    icon: ChartBarIcon,
                    prefix: "/order",
                },
                {
                    name: "Emails",
                    route: { name: "emails" },
                    permission: "view.emails",
                    icon: InboxIcon,
                    prefix: "/email",
                },
                {
                    name: "Setores",
                    route: { name: "sectors" },
                    permission: "manage.internal_roles",
                    icon: UserGroupIcon,
                    prefix: "/sectors",
                },
                {
                    name: "Analytics",
                    route: { name: "analytics.orders" },
                    permission: "view.analytics",
                    icon: ChartBarSquareIcon,
                    prefix: "/analytic",
                },
                {
                    name: "KYC",
                    route: { name: "kyc.dashboard" },
                    permission: "view.kyc",
                    icon: ShieldCheckIcon,
                    prefix: "/kyc",
                },
                {
                    name: "Financeiro",
                    route: { name: "finnancial.dashboard" },
                    permission: "view.bankAccounts",
                    icon: CurrencyDollarIcon,
                    prefix: "/financial",
                },
                {
                    name: "Blacklist",
                    route: { name: "blacklist.index" },
                    permission: "view.blacklist",
                    icon: XMarkIcon,
                },
                {
                    name: "Campanhas",
                    route: { name: "campaigns" },
                    permission: "view.campaigns",
                    icon: MegaphoneIcon,
                },
                {
                    name: "Vitrine",
                    route: { name: "showcase.recommended" },
                    permission: "view.showcase",
                    icon: FolderIcon,
                },
                {
                    name: "Serviços",
                    route: { name: "services" },
                    permission: "view.services",
                    icon: BriefcaseIcon,
                },
                {
                    name: "Ebook",
                    route: { name: "ebook" },
                    permission: "view.services",
                    icon: BookOpenIcon,
                },
                {
                    name: "Ranking",
                    route: { name: "ranking.ranking" },
                    permission: "view.services",
                    icon: ChartBarIcon,
                },
                {
                    name: "Avisos",
                    route: { name: "notices.list" },
                    permission: "view.notices",
                    icon: ExclamationTriangleIcon,
                },
                {
                    name: "Gerentes",
                    route: { name: "account-managers" },
                    permission: "view.managers",
                    icon: AcademicCapIcon,
                },
                {
                    name: "Carteiras",
                    route: { name: "account-portfolio.next-plate" },
                    permission: "view.managers",
                    icon: WalletIcon,
                },
                {
                    name: "Mobile",
                    route: { name: "mobile" },
                    permission: "view.users",
                    icon: DevicePhoneMobileIcon,
                },
                {
                    name: "Vídeos",
                    route: { name: "videos" },
                    permission: "view.users",
                    icon: VideoCameraIcon,
                },
                {
                    name: "Release Notes",
                    route: { name: "release" },
                    permission: "view.releases",
                    icon: ArchiveBoxIcon,
                },
                {
                    name: "Configurações",
                    route: { name: "config" },
                    permission: "view.products",
                    icon: Cog8ToothIcon,
                },
                {
                    name: "Nexus",
                    route: { name: "nexus" },
                    permission: "view.users",
                    icon: ChartBarSquareIcon,
                    prefix: "/nexus",
                },
                {
                    name: "Auditoria",
                    route: { name: "audit" },
                    permission: "view.audits",
                    icon: MagnifyingGlassIcon,
                },
                {
                    name: "Monitoramento",
                    route: { name: "monitoring" },
                    permission: "view.audits",
                    icon: BellAlertIcon,
                    prefix: "/monitoring",
                },
                {
                    name: "Retenção",
                    route: { name: "retention" },
                    permission: "view.audits",
                    icon: ScaleIcon,
                    prefix: "/retention",
                },
                {
                    name: "Sellers",
                    route: { name: "sellers" },
                    permission: "view.audits",
                    icon: BanknotesIcon,
                },
                {
                    name: "Janelas de Risco",
                    route: { name: "account.window.metrics" },
                    permission: "view.audits",
                    icon: ExclamationTriangleIcon,
                    prefix: "/account-window-metrics",
                },
                {
                    name: "Planos de Recebimento",
                    route: { name: "receivement.plans" },
                    icon: BanknotesIcon,
                    permission: "view.receivement_plans",
                    prefix: "/receivement-plans",
                },
                {
                    name: "Webhooks",
                    route: { name: "webhooks" },
                    icon: SignalIcon,
                    permission: "view.webhooks",
                    prefix: "/webhooks",
                },
                {
                    name: "Antifraude",
                    route: { name: "antifraud" },
                    icon: Cog8ToothIcon,
                },
                {
                    name: "Traduções",
                    route: { name: "translations" },
                    permission: "view.translations",
                    icon: Cog8ToothIcon,
                },
                {
                    name: "Pix Automático",
                    route: { name: "pix-recurring-audit" },
                    icon: BanknotesIcon,
                    permission: "view.pix_recurring_audit",
                    prefix: "/pix-recurring",
                },
                // { name: "Projects", href: "#", icon: FolderIcon, current: false },
                // { name: "Calendar", href: "#", icon: CalendarIcon, current: false },
                // { name: "Documents", href: "#", icon: InboxIcon, current: false },
                // { name: "Reports", href: "#", icon: ChartBarIcon, current: false },
            ],
            userNavigation: [
                {
                    name: "Seu Perfil",
                    route: { name: "profile" },
                },
                {
                    name: "Configurações",
                    route: { name: "finnancial.dashboard" },
                },
                {
                    name: "Sair",
                    route: { name: "finnancial.dashboard" },
                },
            ],
        };
    },

    computed: {
        permissions() {
            return permissions;
        },
        ...mapWritableState(Store, [
            "authUser",
            "dark",
            "permissions",
            "token",
        ]),
        hasUser() {
            return this.authUser !== false;
        },

        /**
         * Agrupada ou flat (ordem original), conforme escolha persistida
         * do operador. O formato de saída é sempre [{label, items}].
         */
        /**
         * Key da transicao de pagina: muda so quando a rota de topo muda
         * (matched[1] = a pagina sob o SidebarApp). Abas aninhadas (ex:
         * /user/:id/*) mantem a mesma key e nao remontam, mas os params da
         * rota de topo entram resolvidos na key: navegar de /user/1 para
         * /user/2 remonta a pagina (sem isso a tela ficava no user antigo).
         */
        pageTransitionKey() {
            const section = this.$route.matched[1];

            if (!section) {
                return this.$route.path;
            }

            return section.path.replace(
                /:(\w+)\(?[^/]*?\)?\??(?=\/|$)/g,
                (_, name) => String(this.$route.params[name] ?? ""),
            );
        },

        visibleNavigation() {
            const base = this.sidebarGrouped
                ? this.groupedNavigation
                : [{ label: null, items: this.allowedNavigation }];

            if (this.favoriteItems.length === 0) {
                return base;
            }

            return [{ label: "Favoritos", items: this.favoriteItems }, ...base];
        },

        /**
         * Itens favoritados pelo operador, na ordem em que foram
         * favoritados. Permissões continuam valendo.
         */
        favoriteItems() {
            return this.favorites
                .map((name) =>
                    this.allowedNavigation.find((item) => item.name === name),
                )
                .filter(Boolean);
        },

        allowedNavigation() {
            return this.navigation.filter((item) =>
                this.hasPermission(item.permission),
            );
        },

        /**
         * Sidebar agrupada por domínio. Itens fora do mapa caem em
         * "Plataforma" para nenhum link sumir por engano.
         */
        groupedNavigation() {
            /* "Principal" lidera com o dia a dia de todos os times
               (não só risco). Personalização por usuário (favoritos)
               fica para uma fase seguinte. */
            const sections = {
                Principal: [
                    "Usuários",
                    "Trocas de E-mail",
                    "Vendas",
                    "Compliance",
                    "Financeiro",
                ],
                Operação: [
                    "Produtos",
                    "Analytics",
                    "Emails",
                    "Campanhas",
                    "Vitrine",
                    "Serviços",
                    "Ebook",
                    "Ranking",
                    "Avisos",
                    "Mobile",
                    "Vídeos",
                ],
                Risco: [
                    "Monitoramento",
                    "Retenção",
                    "Auditoria",
                    "KYC",
                    "Sellers",
                    "Janelas de Risco",
                    "Blacklist",
                    "Antifraude",
                    "Pix Automático",
                ],
                Dinheiro: [
                    "Carteiras",
                    "Planos de Recebimento",
                    "FDIC",
                    "Gerentes",
                    "Nexus",
                ],
                Plataforma: [
                    "Setores",
                    "Webhooks",
                    "Configurações",
                    "Traduções",
                    "Release Notes",
                ],
            };

            const sectionOf = (item) =>
                Object.keys(sections).find((label) =>
                    sections[label].includes(item.name),
                ) ?? "Plataforma";

            return Object.keys(sections)
                .map((label) => ({
                    label,
                    items: this.allowedNavigation.filter(
                        (item) => sectionOf(item) === label,
                    ),
                }))
                .filter((group) => group.items.length > 0);
        },
    },

    async mounted() {
        if (!this.authUser) {
            await this.fetchAuthUser();
        }

        window.addEventListener("keydown", this.onKeydown);
    },

    beforeUnmount() {
        window.removeEventListener("keydown", this.onKeydown);
    },

    methods: {
        ...mapActions(Store, ["fetchAuthUser", "logout"]),
        isRouteActive(prefix) {
            if (!prefix) {
                return false;
            }
            return this.$route.path.startsWith(prefix);
        },

        toggleFavorite(name) {
            this.favorites = this.favorites.includes(name)
                ? this.favorites.filter((item) => item !== name)
                : [...this.favorites, name];
            localStorage.setItem(
                "smaug_sidebar_favorites",
                JSON.stringify(this.favorites),
            );
        },

        chooseMenuLayout(grouped) {
            this.sidebarGrouped = grouped;
            this.showMenuHint = false;
            localStorage.setItem("smaug_sidebar_grouped", grouped ? "1" : "0");
        },

        onKeydown(event) {
            if ((event.metaKey || event.ctrlKey) && event.key === "k") {
                event.preventDefault();
                this.paletteOpen = !this.paletteOpen;
            }
        },
    },
};
</script>

<style scoped>
.sidebar-nav-scroll {
    scrollbar-width: none;
    scrollbar-gutter: stable;
}

.sidebar-desktop:hover .sidebar-nav-scroll {
    scrollbar-width: thin;
    scrollbar-color: rgb(107 114 128 / 0.45) transparent;
}

.sidebar-nav-scroll::-webkit-scrollbar {
    width: 4px;
}

.sidebar-nav-scroll::-webkit-scrollbar-track {
    background: transparent;
}

.sidebar-nav-scroll::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 9999px;
}

.sidebar-desktop:hover .sidebar-nav-scroll::-webkit-scrollbar-thumb {
    background-color: rgb(107 114 128 / 0.45);
}
</style>
